import { render } from "./IconoRetirado.vue?vue&type=template&id=7cf2d15e"
import script from "./IconoRetirado.vue?vue&type=script&lang=js"
export * from "./IconoRetirado.vue?vue&type=script&lang=js"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__